<template>
  <div v-if="isLoggedIn && appParams && appParams.staticTranslations">
    <div id="itb-carts-page" v-if="showCartList || showOrderList">
      <h2 class="itb-cart-title" style="margin-top: 78px">
        {{ appParams.staticTranslations["carts.your_carts"] }}
      </h2>
      <div class="container">
        <table class="table table-hover itb-cart-graphics-list">
          <thead>
            <tr class="itb-table-header">
              <th colspan="3" scope="colgroup" class="row">
                <label
                  for="itb-all-docs"
                  class="itb-checkbox-label itb-filter-1"
                  ><input
                    type="radio"
                    id="itb-all-docs"
                    name="itb-buy-docs"
                    value="all"
                    v-model="selectedList"
                  /><span class="itb-checkbox"></span>
                  {{ appParams.staticTranslations["carts.all"] }}</label
                >

                <label
                  for="itb-sent-inquiries"
                  class="itb-checkbox-label itb-filter-2"
                  ><input
                    type="radio"
                    id="itb-sent-inquiries"
                    name="itb-buy-docs"
                    value="inquiries"
                    v-model="selectedList"
                  /><span class="itb-checkbox"></span
                  >{{
                    appParams.staticTranslations["carts.sent_inquiries"]
                  }}</label
                >

                <label
                  for="itb-saved-carts-docs"
                  class="itb-checkbox-label itb-filter-3"
                  ><input
                    type="radio"
                    id="itb-saved-carts-docs"
                    name="itb-buy-docs"
                    value="carts"
                    v-model="selectedList"
                  /><span class="itb-checkbox"></span
                  >{{
                    appParams.staticTranslations["carts.saved_carts"]
                  }}</label
                >
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="itb-cart-list"
              v-for="(element, key) in mergedData"
              v-if="
                selectedList == 'all' ||
                (selectedList == 'carts' && element[0].cart_id) ||
                (selectedList == 'inquiries' && element[0].order_id)
              "
            >
              <td
                :class="{
                  'itb-listed-cart': element[0].cart_id ? true : false,
                  'itb-listed-order': element[0].order_id ? true : false,
                }"
              >
                <img
                  :src="
                    element[0].cart_id
                      ? '/images/shopping-cart-solid.svg'
                      : '/images/receipt-solid.svg'
                  "
                  :alt="
                    element[0].cart_id
                      ? appParams.staticTranslations['carts.cart']
                      : appParams.staticTranslations['carts.inquiry']
                  "
                  class="itb-icon itb-paperplane"
                />{{
                  element[0].cart_id
                    ? appParams.staticTranslations["carts.cart"]
                    : appParams.staticTranslations["carts.inquiry"]
                }}
                {{ element[0].internal_id ? element[0].internal_id : "-" }}
              </td>
              <td class="itb-cart-items">
                <span v-for="item in element">
                  {{ item.name }}
                </span>
              </td>
              <td class="itb-cart-date">
                {{
                  element[0].order_id
                    ? appParams.staticTranslations["carts.sent_on"]
                    : appParams.staticTranslations["carts.saved_on"]
                }}
                {{ element[0].displayed_date }}
              </td>
              <td class="itb-handled-by">
                {{
                  appParams.staticTranslations["carts.done_by"] +
                  " " +
                  element[0].handledBy
                }}
              </td>
              <td style="position: relative">
                <button
                  type="button"
                  :title="
                    element[0].cart_id ? buttonTooltip : buttonTooltipOrder
                  "
                  class="btn btn-outline-primary p-0"
                  @click="
                    element[0].cart_id
                      ? seeCart(element[0].cart_id)
                      : seeOrder(element[0].order_id)
                  "
                >
                  <span
                    v-bind:class="{
                      mdi: showEye,
                      'mdi-eye': showEye,
                    }"
                  ></span>
                  {{ element[0].cart_id ? viewBasket : viewOrder }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else class="container">
      <div class="row">
        <div
          class="col-12 col-sm-8 offset-sm-2 col-md-4 col-lg-4 offset-md-4 offset-lg-4 pt-3 mb-5 text-center"
        >
          <div class="alert itb-alert alert-info" role="alert">
            {{ appParams.staticTranslations["carts.no_active_cart"] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      pageParams: [],
      showCartList: false,
      showOrderList: false,
      graphics: {},
      viewBasket: "",
      viewOrder: "",
      showEye: false,
      buttonTooltip: "",
      buttonTooltipOrder: "",
      orderDetails: {},
      mergedData: [],
      selectedList: "all",
      showRow: true,
    };
  },

  computed: {
    ...mapGetters({
      appParams: "getAppParams",
      isLoggedIn: "getClientLogged",
      profile: "getClientProfile",
    }),
  },
  created() {
    // when cart is accessed without being logged in, it will redirect to home
    this.logRedirect();
    this.getCarts();
    this.getOrders();
  },

  watch: {
    "appParams.staticTranslations": function (newVal, oldVal) {
      this.onResize();
    },
  },

  mounted() {
    window.addEventListener("resize", this.onResize);
    this.onResize();

    this.getSavedCartsPage();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapActions(["setPageParams", "setFormParams"]),
    logRedirect() {
      if (!this.isLoggedIn) {
        if (this.$route.name != "home") {
          this.$router.push("home");
        }
      }
    },

    getSavedCartsPage() {
      axios
        .get("/getSavedCartsPage")
        .then((response) => {
          this.pageParams = response.data.params;

          this.setPageParams(this.pageParams);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getCarts() {
      await axios
        .post("/getCarts", this.profile)
        .then((response) => {
          this.graphics = response.data;
          if (Object.keys(this.graphics).length === 0) {
            this.showCartList = false;
          } else {
            this.showCartList = true;
            this.adjustCartValues();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getOrders() {
      if (!this.isLoggedIn) {
        this.$router.push("/");
      } else {
        await axios
          .post("/getOrders", this.profile)
          .then((response) => {
            this.orderDetails = response.data;
            if (Object.keys(this.orderDetails).length === 0) {
              this.showOrderList = false;
            } else {
              this.showOrderList = true;
              this.adjustOrderValues();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    adjustCartValues() {
      Object.values(this.graphics).forEach((cart) => {
        // adjust date format
        cart[0].date = cart[0].created_at;
        cart[0].displayed_date = cart[0].created_at;
        cart[0].displayed_date = new Date(cart[0].displayed_date);
        cart[0].displayed_date = cart[0].displayed_date.toLocaleString(
          "en-GB",
          {
            day: "numeric",
            month: "numeric",
            year: "numeric",
          }
        );

        // truncate item list of each cart
        if (cart.length > 3) {
          cart.length = 3;
          let obj = {};
          obj.name = "...";
          obj.name_variant = "...";
          cart.push(obj);
        }

        //put commas in each item's cart except the last
        let shouldSkip = false;
        let i = 0;
        cart.forEach((item) => {
          i = i + 1;
          if (shouldSkip) {
            return;
          }
          if (i === cart.length) {
            shouldSkip = true;
            return;
          }
          item.name = item.name + ", ";
          item.name_variant = item.name_variant + ", ";
        });

        this.mergedData.push(cart);
      });
      this.sortData();
    },

    adjustOrderValues() {
      Object.values(this.orderDetails).forEach((order) => {
        // adjust date format
        order[0].date = order[0].created_at;
        order[0].displayed_date = order[0].created_at;
        order[0].displayed_date = new Date(order[0].displayed_date);
        order[0].displayed_date = order[0].displayed_date.toLocaleString(
          "en-GB",
          {
            day: "numeric",
            month: "numeric",
            year: "numeric",
          }
        );

        // truncate item list of each order
        if (order.length > 3) {
          order.length = 3;
          let obj = {};
          obj.name = "...";
          order.push(obj);
        }

        //put commas in each item's order except the last
        let shouldSkipOrder = false;
        let i = 0;
        order.forEach((item) => {
          i = i + 1;
          if (shouldSkipOrder) {
            return;
          }
          if (i === order.length) {
            shouldSkipOrder = true;
            return;
          }
          item.name = item.name + ", ";
        });

        this.mergedData.push(order);
      });
      this.sortData();
    },

    onResize() {
      if (this.appParams && this.appParams.staticTranslations) {
        if (window.innerWidth < 960) {
          this.viewBasket = "";
          this.viewOrder = "";
          this.showEye = true;
          this.buttonTooltip =
            this.appParams.staticTranslations["carts.view_basket"];
          this.buttonTooltipOrder =
            this.appParams.staticTranslations["carts.view_order"];
        } else {
          this.viewBasket =
            this.appParams.staticTranslations["carts.view_basket"];
          this.viewOrder =
            this.appParams.staticTranslations["carts.view_order"];
          this.showEye = false;
          this.buttonTooltip = "";
          this.buttonTooltipOrder = "";
        }
      }
    },

    seeCart(cart_id) {
      let selectedCart = "cart" + cart_id;
      this.$router.push(`/saved-carts/carts/${selectedCart}`);
    },

    sortData() {
      if (
        Object.keys(this.orderDetails).length > 0 ||
        Object.keys(this.graphics).length > 0
      ) {
        this.mergedData.sort(sortByDate);

        function sortByDate(a, b) {
          return new Date(b[0].date) - new Date(a[0].date);
        }
      }
    },

    seeOrder(order_id) {
      let selectedOrder = "order" + order_id;
      this.$router.push(`/saved-carts/orders/${selectedOrder}`);
    },
  },
};
</script>
